import { render } from "./ModalAlertModel.vue?vue&type=template&id=bc9273c6&scoped=true"
import script from "./ModalAlertModel.vue?vue&type=script&lang=js"
export * from "./ModalAlertModel.vue?vue&type=script&lang=js"

import "./ModalAlertModel.vue?vue&type=style&index=0&id=bc9273c6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9273c6"]])

export default __exports__